import React, { useEffect, useState } from "react";

import $ from "jquery";
import { Spinner } from "reactstrap";
// import userImage from "../../../../assets/images/user-image.png";
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import "bootstrap-select/dist/js/bootstrap-select.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import userImage from "../../../../assets/images//user-image.png";
import {
	URL,
	checkRolePermissions,
	checkSubsTeacherPermissions,
	scaleTypeCode,
} from "../../../../utils/Constants";
import { handleError } from "../../../../utils/Utils";
import StudentReportGeneration from "./StudentReportGeneration";
const animatedComponents = makeAnimated();

const StudentDetailRevamp = (props) => {
	const [commentIdx, setCommentIdx] = useState(null);
	const [trigger, setTrigger] = useState(false);
	const [finalizeReportPermission, setFinalizeReportPermission] =
		useState(null);
	const [unFinalizeReportPermission, setUnFinalizeReportPermission] =
		useState(null);
	const [students, setStudents] = useState([]);
	const [selectedLvlVal, setSelectedLvlVal] = useState({});
	useEffect(() => {
		checkPermissions();
	}, []);

	useEffect(() => {
		setTrigger(!trigger);
		return () => {
			$(".selectpicker").selectpicker("destroy");
		};
	}, [props.studentData]);

	useEffect(() => {
		$(".selectpicker").selectpicker();
		$(".selectpicker").selectpicker("refresh");
		return () => {
			// $(".selectpicker").selectpicker("destroy");
		};
	}, [trigger]);

	const checkPermissions = () => {
		let finalizeReportPermissionCheck =
			checkRolePermissions(
				"finalize-subject-assessment",
				"activity",
				props.widgetName,
			) ||
			checkSubsTeacherPermissions(
				"finalize-subject-assessment",
				"activity",
				props.widgetName,
			);

		let unFinalizeReportPermissionCheck =
			checkRolePermissions(
				"unfinalize-subject-assessment",
				"activity",
				props.widgetName,
			) ||
			checkSubsTeacherPermissions(
				"unfinalize-subject-assessment",
				"activity",
				props.widgetName,
			);

		setFinalizeReportPermission(finalizeReportPermissionCheck);
		setUnFinalizeReportPermission(unFinalizeReportPermissionCheck);
	};

	const getTheoryPracticalLength = (item) => {
		if (item.hasTheory && item.hasPractical) {
			return (
				item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForPractical
					.length +
				item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForTheory
					.length
			);
		} else if (item.hasTheory) {
			return item.subjectAssessmentScalesTheoryPractcal
				.assessmentScalesForTheory.length;
		} else if (item.hasPractical) {
			return item.subjectAssessmentScalesTheoryPractcal
				.assessmentScalesForPractical.length;
		} else {
			return 0;
		}
	};

	const getTheoryPracticalTitle = (item) => {
		if (item.hasTheory && item.hasPractical) {
			return (
				<>
					{item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForTheory.map(
						(el) => (
							<th rowSpan={1}>
								{" "}
								Th {`${el.theoryMax ? `(${el.theoryMax})` : ""}`}
							</th>
						),
					)}
					{item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForPractical.map(
						(el) => (
							<th rowSpan={1}>
								Pr {`${el.practicalMax ? `(${el.practicalMax})` : ""}`}
							</th>
						),
					)}
				</>
			);
		} else if (item.hasTheory) {
			return item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForTheory.map(
				(el) => (
					<th rowSpan={1}>Th {`${el.theoryMax ? `(${el.theoryMax})` : ""}`}</th>
				),
			);
		} else if (item.hasPractical) {
			return item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForPractical.map(
				(el) => (
					<th rowSpan={1}>
						Pr {`${el.practicalMax ? `(${el.practicalMax})` : ""}`}
					</th>
				),
			);
		} else {
			return <></>;
		}
	};

	// const customStyles = {
	// 	control: (provided) => ({
	// 		...provided,
	// 		backgroundColor: "red",
	// 		color: 'white !important'
	// 	}),
	// };

	const getTheoryPracticalTitleData = (item, student) => {
		const filtredStudentSub = student?.subject?.[item.name]?.[0];

		if (!filtredStudentSub) {
			const finalPracticalAssessmentDetail =
				item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForPractical.map(
					(el) => "N/A",
				);

			const finalTheoryAssessmentDetail =
				item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForTheory.map(
					(el) => {
						return "N/A";
					},
				);

			if (item.hasTheory && item.hasPractical) {
				return (
					<>
						{finalPracticalAssessmentDetail.map((assessment) => (
							<td className="text-center">N/A</td>
						))}
						{finalTheoryAssessmentDetail.map((assessment) => (
							<td className="text-center">N/A</td>
						))}
					</>
				);
			} else if (item.hasTheory) {
				return (
					<>
						{finalTheoryAssessmentDetail.map((assessment) => (
							<td className="text-center">N/A</td>
						))}
					</>
				);

				// return item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForTheory.map(
				//   (el) => <td>td {`(${el.scaleName})`}</td>
				// );
			} else if (item.hasPractical) {
				return item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForPractical.map(
					(el) => <td>N/A</td>,
				);
			} else {
				return <></>;
			}

			// console.log(finalTheoryAssessmentDetail,"final theory assessent detaujl ")

			return;
		}

		// let theoryAssesmentDetail =filtredStudentSub?.theorySubjectAssessments?.filter(
		//     (data) => data.admissionId == student.admissionId
		//   ) ?? [];

		const finalTheoryAssessmentDetail =
			filtredStudentSub?.theorySubjectAssessments;
		// let finalTheoryAssessmentDetail =
		//   item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForTheory.map(
		//     (el) => {
		//       let theroyDetail = theoryAssesmentDetail.find(
		//         (itm) => itm.assessmentScaleId == el.id
		//       );
		//       return {
		//         ...theroyDetail,
		//         assessmentScale: el,
		//         assessmentScaleTypeCode: el.assessmentScaleTypeCode,
		//       };
		//     }
		//   );

		const finalPracticalAssessmentDetail =
			filtredStudentSub.practicalSubjectAssessments;
		// let finalPracticalAssessmentDetail =
		//   item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForPractical.map(
		//     (el) => {
		//       let practicalDetail = practicalAssesmentDetail.find(
		//         (itm) => itm.assessmentScaleId == el.id
		//       );
		//       return {
		//         ...practicalDetail,
		//         assessmentScale: el,
		//         assessmentScaleTypeCode: el.assessmentScaleTypeCode,
		//       };
		//     }
		//   );

		if (item.hasTheory && item.hasPractical) {
			return (
				<>
					{finalTheoryAssessmentDetail.map((assessment) => (
						<td className="text-center">
							{assessment.isTheoryAbsent ? null : (
								<div>
									{assessment.assessmentScaleTypeCode ===
										scaleTypeCode.level ? (
										<>
											<Select
												isClearable
												className="w-100"
												closeMenuOnSelect={true}
												// components={animatedComponents}
												styles={{
													control: (baseStyles, state) => ({
														...baseStyles,
														backgroundColor: assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelTheoryId)?.level ?
															assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelTheoryId)?.level : "white",
													}),
													option: (styles, { data, isDisabled, isFocused, isSelected }) => {
														return {
															...styles,
															backgroundColor: isFocused ? data.label : "",
															color: 'black',
														};
													},
												}}
												components={customComponents}
												value={
													assessment.assessmentScale.assessmentScaleLevels
														? assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId)
															? [
																{
																	value: assessment.assessmentScaleLevelTheoryId,
																	label: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).levelType === "colourStickers"
																		? assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).level
																		: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).levelType === "image"
																			? (
																				<img
																					src={URL.imageSelectURL + assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).level}
																					className="img-responsive"
																					height="42"
																					width="42"
																				/>
																			)
																			: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).level,
																},
															]
															: []
														: []
												}
												options={
													assessment.assessmentScale.assessmentScaleLevels
														? assessment.assessmentScale.assessmentScaleLevels.map((scaleLevel) => {
															if (scaleLevel.levelType === "colourStickers") {
																return {
																	value: scaleLevel.id,
																	label: scaleLevel.level,
																	style: {
																		backgroundColor: scaleLevel.level,
																		color: "#fff",
																		fontSize: "25px",
																	},
																};
															} else if (scaleLevel?.levelType === "image") {
																return {
																	value: scaleLevel?.id,
																	label: {
																		type: "img",
																		src: URL.imageSelectURL + scaleLevel?.level,
																		height: "42",
																		width: "42"
																	}
																};
															} else {
																return {
																	value: scaleLevel.id,
																	label: scaleLevel.level,
																};
															}
														})
														: []
												}
												isDisabled={
													assessment.isFinalized ||
													(props.finalizeUnFinalizeVal[item.name] &&
														!props.finalizeUnFinalizeVal[item.name] ===
														true)
												}
												name="level"
												onChange={(e) => {

													setSelectedLvlVal(e);
													props.handleAssessmentScaleForTheoryLevelChange(e, assessment, item.name)
												}

												}
												placeholder="Select Level"
											/>
										</>
									) : assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.mark ? (
										assessment.assessmentScale && (
											<div className="d-flex justify-content-center">
												<div>
													<input
														type="number"
														min={0}
														max={assessment.assessmentScale?.theoryMax}
														value={assessment?.theoryObtainedMarks ?? ""}
														disabled={
															assessment.isFinalized ||
															(props.finalizeUnFinalizeVal[item.name] &&
																!props.finalizeUnFinalizeVal[item.name] ===
																true)
														}
														//disabled={assessment.isFinalized || (props.finalizeUnFinalizeVal[item.name] && !props.finalizeUnFinalizeVal[item.name]===true)}
														style={{
															border:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? // border:(assessment.isFinalized ||(props.finalizeUnFinalizeVal[item.name] && !props.finalizeUnFinalizeVal[item.name]===true))
																	"1px solid grey"
																	: "1px solid black",
															height: "38px",
															width: "55px",
															textAlign: "center",

															background:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? "#dddddd"
																	: "",
															color:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? "grey"
																	: "",
														}}
														onChange={(count) => {

															props.theoryCounterHandler(
																count.target.value,
																assessment,
																item.name,
															)
														}
														}
														step={0.5}
													/>
												</div>
											</div>
										)
									) : assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.gradePoint ? (
										<Select
											isClearable
											className="w-100"
											closeMenuOnSelect={true}
											// components={animatedComponents}
											components={customComponents}
											value={
												assessment?.assessmentScaleGradePointTheoryId
													? [
														{
															label: assessment?.assessmentScale?.assessmentScaleGradePoints?.filter((item) => item?.id === assessment?.assessmentScaleGradePointTheoryId)[0]?.grade ?? "",
															value: assessment?.assessmentScaleGradePointTheoryId ?? "",
														},
													]
													: null
											}
											options={
												assessment?.assessmentScale?.assessmentScaleGradePoints
													? assessment.assessmentScale.assessmentScaleGradePoints.map((scaleGradePoint) => ({
														value: scaleGradePoint?.id,
														label: scaleGradePoint?.grade,
													}))
													: []
											}
											isDisabled={
												assessment.isFinalized ||
												(props.finalizeUnFinalizeVal[item.name] &&
													!props.finalizeUnFinalizeVal[item.name] ===
													true)
											}
											placeholder="Select Grade Point"
											name="gradePoint"
											onChange={(e) => {

												props.handleAssessmentScaleTheoryGradePointChange(
													e,
													assessment,
													item.name,
												)
											}
											}
										/>
									) : null}
								</div>
							)}

							<div className="mt-2">
								<input
									// id={
									//   "isTheoryAbsent" +
									//   assessment.assessmentScale.assessmentScaleTypeCode +
									//   i +
									//   idx
									// }
									type="checkbox"
									name="isTheoryAbsent"
									checked={assessment.isTheoryAbsent}
									disabled={
										assessment.isFinalized ||
										(props.finalizeUnFinalizeVal[item.name] &&
											!props.finalizeUnFinalizeVal[item.name] === true)
									}
									onChange={(e) => {

										props.handleIsAbsentForTheory(e, assessment, item.name)
									}
									}
								/>
								<label
									// htmlFor={
									//   "isTheoryAbsent" +
									//   assessment.assessmentScale.assessmentScaleTypeCode +
									//   i +
									//   idx
									// }
									style={{
										paddingLeft: "5px",
										position: "relative",
										top: "-3px",
									}}
								>
									<strong>Is Absent</strong>
								</label>
							</div>
						</td>
					))}

					{finalPracticalAssessmentDetail.map((assessment) => (
						<td className="text-center">
							{assessment.isPracticalAbsent ? null : (
								<div>
									{assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.level ? (
										<>
											<Select
												isClearable
												className="w-100"
												closeMenuOnSelect={true}
												// components={animatedComponents}

												// styles={customStyles}
												styles={{
													control: (baseStyles, state) => ({
														...baseStyles,
														backgroundColor: assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.level ?
															assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.level : "white",
													}),
													option: (styles, { data, isFocused }) => {
														return {
															...styles,
															backgroundColor: isFocused ? data.label : "",
															color: 'black',
														};
													},
												}}
												components={customComponents}
												value={
													assessment.assessmentScale.assessmentScaleLevels
														? assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelPracticalId)
															? [
																{
																	value: assessment.assessmentScaleLevelPracticalId,
																	label: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelPracticalId).levelType === "colourStickers"
																		? assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelPracticalId).level
																		: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelPracticalId).levelType === "image"
																			? (
																				<img
																					src={URL.imageSelectURL + assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelPracticalId).level}
																					className="img-responsive"
																					height="42"
																					width="42"
																				/>
																			)
																			: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelPracticalId).level,
																},
															]
															: []
														: []
												}
												options={
													assessment.assessmentScale.assessmentScaleLevels
														? assessment.assessmentScale.assessmentScaleLevels.map((scaleLevel) => {
															if (scaleLevel.levelType === "colourStickers") {
																return {
																	value: scaleLevel.id,
																	label: scaleLevel.level,
																	style: {
																		backgroundColor: scaleLevel.level,
																		color: "#fff",
																		fontSize: "25px",
																	},
																};
															} else if (scaleLevel.levelType === "image") {
																return {
																	value: scaleLevel.id,
																	label: (
																		<img
																			src={URL.imageSelectURL + scaleLevel.level}
																			className="img-responsive"
																			height="42"
																			width="42"
																		/>
																	),
																};
															} else {
																return {
																	value: scaleLevel.id,
																	label: scaleLevel.level,
																};
															}
														})
														: []
												}
												isDisabled={
													assessment.isFinalized ||
													(props.finalizeUnFinalizeVal[item.name] &&
														!props.finalizeUnFinalizeVal[item.name] ===
														true)
												}
												name="level"
												onChange={(e) => {

													setSelectedLvlVal(e);
													props.handleAssessmentScaleForPracticalLevelChange(e, assessment, item.name)
												}
												}
												placeholder="Select Level"
											/>
										</>
									) : assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.mark ? (
										<>
											<input
												type="number"
												max={
													assessment.assessmentScale
														? assessment.assessmentScale.practicalMax
															? assessment.assessmentScale.practicalMax
															: 100
														: 100
												}
												// count={
												//   assess?.practicalObtainedMarks
												// }
												value={assessment?.practicalObtainedMarks ?? ""}
												disabled={
													assessment.isFinalized ||
													(props.finalizeUnFinalizeVal[item.name] &&
														!props.finalizeUnFinalizeVal[item.name] === true)
												}
												style={{
													border:
														assessment.isFinalized ||
															(props.finalizeUnFinalizeVal[item.name] &&
																!props.finalizeUnFinalizeVal[item.name] === true)
															? "1px solid grey"
															: "1px solid black",
													height: "38px",
													width: "55px",
													textAlign: "center",

													background:
														assessment.isFinalized ||
															(props.finalizeUnFinalizeVal[item.name] &&
																!props.finalizeUnFinalizeVal[item.name] === true)
															? "#dddddd"
															: "",
													color:
														assessment.isFinalized ||
															(props.finalizeUnFinalizeVal[item.name] &&
																!props.finalizeUnFinalizeVal[item.name] === true)
															? "grey"
															: "",
												}}
												onChange={(count) => {

													props.practicalCounterHandler(
														count.target.value,
														assessment,
														item.name,
													)
												}
												}
												step={0.5}
											/>
										</>
									) : assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.gradePoint ? (
										<>
											<Select
												isClearable
												className="w-100"
												closeMenuOnSelect={true}
												// components={animatedComponents}
												components={customComponents}
												value={
													assessment?.assessmentScaleGradePointPracticalId
														? [
															{
																label: assessment?.assessmentScale?.assessmentScaleGradePoints?.filter((item) => item?.id === assessment?.assessmentScaleGradePointPracticalId)[0]?.grade ?? "",
																value: assessment?.assessmentScaleGradePointPracticalId ?? "",
															},
														]
														: null
												}
												options={
													assessment?.assessmentScale?.assessmentScaleGradePoints
														? assessment.assessmentScale.assessmentScaleGradePoints.map((scaleGradePoint) => ({
															value: scaleGradePoint?.id,
															label: scaleGradePoint?.grade,
														}))
														: []
												}
												isDisabled={
													assessment.isFinalized ||
													(props.finalizeUnFinalizeVal[item.name] &&
														!props.finalizeUnFinalizeVal[item.name] ===
														true)
												}
												placeholder="Select Grade Point"
												name="gradePoint"
												onChange={(e) => {

													props.handleAssessmentScalePracticalGradePointChange(
														e,
														assessment,
														item.name,
													)
												}
												}
											/>
										</>
									) : null}
								</div>
							)}

							<div className="mt-2">
								<input
									// id={
									//   "isPracticalAbsent" +
									//   assessmentScale.assessmentScaleTypeCode +
									//   i +
									//   idx
									// }
									type="checkbox"
									name="isPracticalAbsent"
									checked={assessment?.isPracticalAbsent}
									disabled={
										assessment.isFinalized ||
										(props.finalizeUnFinalizeVal[item.name] &&
											!props.finalizeUnFinalizeVal[item.name] === true)
									}
									onChange={(e) => {

										props.handleIsAbsentForPractical(e, assessment, item.name)
									}
									}
								/>
								<label
									// htmlFor={
									//   "isPracticalAbsent" +
									//   assessmentScale.assessmentScaleTypeCode +
									//   i +
									//   idx
									// }
									style={{
										paddingLeft: "5px",
										position: "relative",
										top: "-3px",
									}}
								>
									<strong>Is Absent</strong>
								</label>
							</div>
						</td>
					))}
				</>
			);
		} else if (item.hasTheory) {
			return (
				<>
					{finalTheoryAssessmentDetail.map((assessment) => (
						<td className="text-center">
							{assessment.isTheoryAbsent ? null : (
								<div>
									{assessment.assessmentScaleTypeCode ===
										scaleTypeCode.level ? (
										<Select
											isClearable
											className="w-100"
											closeMenuOnSelect={true}
											// components={animatedComponents}

											styles={{
												control: (baseStyles, state) => ({
													...baseStyles,
													backgroundColor: assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelTheoryId)?.level ?
														assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelTheoryId)?.level : "white",
												}),
												option: (styles, { data, isFocused }) => {
													return {
														...styles,
														backgroundColor: isFocused ? data.label : "",
														color: 'black',
													};
												},
											}}
											components={customComponents}
											value={
												assessment.assessmentScale.assessmentScaleLevels
													? assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId)
														? [
															{
																value: assessment.assessmentScaleLevelTheoryId,
																label: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).levelType === "colourStickers"
																	? assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).level
																	: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).levelType === "image"
																		? (
																			<img
																				src={URL.imageSelectURL + assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).level}
																				className="img-responsive"
																				height="42"
																				width="42"
																			/>
																		)
																		: assessment.assessmentScale.assessmentScaleLevels.find((scaleLevel) => scaleLevel.id === assessment?.assessmentScaleLevelTheoryId).level,
															},
														]
														: []
													: []
											}
											options={
												assessment.assessmentScale.assessmentScaleLevels
													? assessment.assessmentScale.assessmentScaleLevels.map((scaleLevel) => {
														if (scaleLevel.levelType === "colourStickers") {
															return {
																value: scaleLevel.id,
																label: scaleLevel.level,
																style: {
																	backgroundColor: scaleLevel.level,
																	color: "#fff",
																	fontSize: "25px",
																},
															};
														} else if (scaleLevel.levelType === "image") {
															return {
																value: scaleLevel.id,
																label: {
																	type: "img",
																	src: URL.imageSelectURL + scaleLevel?.level,
																	height: "42",
																	width: "42"
																}
															};
														} else {
															return {
																value: scaleLevel.id,
																label: scaleLevel.level,
															};
														}
													})
													: []
											}
											isDisabled={
												assessment.isFinalized ||
												(props.finalizeUnFinalizeVal[item.name] &&
													!props.finalizeUnFinalizeVal[item.name] ===
													true)
											}
											name="level"
											onChange={(e) => {

												setSelectedLvlVal(e);
												props.handleAssessmentScaleForTheoryLevelChange(e, assessment, item.name)
											}

											}
											placeholder="Select Level"
										/>
									) : assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.mark ? (
										assessment.assessmentScale && (
											<div className="d-flex justify-content-center">
												<div>
													<input
														type="number"
														min={0}
														max={assessment.assessmentScale?.theoryMax}
														value={assessment?.theoryObtainedMarks ?? ""}
														disabled={
															assessment.isFinalized ||
															(props.finalizeUnFinalizeVal[item.name] &&
																!props.finalizeUnFinalizeVal[item.name] ===
																true)
														}
														style={{
															border:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? "1px solid grey"
																	: "1px solid black",
															height: "38px",
															width: "55px",
															textAlign: "center",

															background:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? "#dddddd"
																	: "",
															color:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? "grey"
																	: "",
														}}
														onChange={(count) => {

															props.theoryCounterHandler(
																count.target.value,
																assessment,
																item.name,
															)
														}
														}
														step={0.5}
													/>
												</div>
											</div>
										)
									) : assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.gradePoint ? (
										<>
											<Select
												isClearable
												className="w-100"
												closeMenuOnSelect={true}
												// components={animatedComponents}
												components={customComponents}
												value={
													assessment?.assessmentScaleGradePointTheoryId
														? [
															{
																label: assessment?.assessmentScale?.assessmentScaleGradePoints?.filter((item) => item?.id === assessment?.assessmentScaleGradePointTheoryId)[0]?.grade ?? "",
																value: assessment?.assessmentScaleGradePointTheoryId ?? "",
															},
														]
														: null
												}
												options={
													assessment?.assessmentScale?.assessmentScaleGradePoints
														? assessment.assessmentScale.assessmentScaleGradePoints.map((scaleGradePoint) => ({
															value: scaleGradePoint?.id,
															label: scaleGradePoint?.grade,
														}))
														: []
												}
												isDisabled={
													assessment.isFinalized ||
													(props.finalizeUnFinalizeVal[item.name] &&
														!props.finalizeUnFinalizeVal[item.name] ===
														true)
												}
												placeholder="Select Grade Point"
												name="gradePoint"
												onChange={(e) => {

													props.handleAssessmentScaleTheoryGradePointChange(
														e,
														assessment,
														item.name,
													)
												}
												}
											/>
										</>
									) : null}
								</div>
							)}

							<div className="mt-2">
								<input
									// id={
									//   "isTheoryAbsent" +
									//   assessment.assessmentScale.assessmentScaleTypeCode +
									//   i +
									//   idx
									// }
									type="checkbox"
									name="isTheoryAbsent"
									checked={assessment.isTheoryAbsent}
									disabled={
										assessment.isFinalized ||
										(props.finalizeUnFinalizeVal[item.name] &&
											!props.finalizeUnFinalizeVal[item.name] === true)
									}
									onChange={(e) => {

										props.handleIsAbsentForTheory(e, assessment, item.name)
									}
									}
								/>
								<label
									// htmlFor={
									//   "isTheoryAbsent" +
									//   assessment.assessmentScale.assessmentScaleTypeCode +
									//   i +
									//   idx
									// }
									style={{
										paddingLeft: "5px",
										position: "relative",
										top: "-3px",
									}}
								>
									<strong>Is Absent</strong>
								</label>
							</div>
						</td>
					))}
				</>
			);

			// return item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForTheory.map(
			//   (el) => <td>td {`(${el.scaleName})`}</td>
			// );
		} else if (item.hasPractical) {
			// return item.subjectAssessmentScalesTheoryPractcal.assessmentScalesForPractical.map(
			//   (el) => <td>Pr {`(${el.scaleName})`}</td>
			// );
			return (
				<>
					{finalPracticalAssessmentDetail.map((assessment) => (
						<td className="text-center">
							{assessment.isPracticalAbsent ? null : (
								<div>
									{assessment.assessmentScaleTypeCode ===
										scaleTypeCode.level ? (
										<>
											<Select
												isClearable
												className="w-100"
												closeMenuOnSelect={true}
												// components={animatedComponents}

												styles={{
													control: (baseStyles, state) => ({
														...baseStyles,
														backgroundColor: assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.level ?
															assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.level : "white",
													}),
													option: (styles, { data, isFocused }) => {
														return {
															...styles,
															backgroundColor: isFocused ? data.label : "",
															color: 'black',
														};
													},
												}}
												components={customComponents}
												value={
													assessment?.assessmentScale?.assessmentScaleLevels
														? assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)
															? [
																{
																	value: assessment?.assessmentScaleLevelPracticalId,
																	label: assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.levelType === "colourStickers"
																		? assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.level
																		: assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.levelType === "image"
																			? (
																				<img
																					src={URL.imageSelectURL + assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.level}
																					className="img-responsive"
																					height="42"
																					width="42"
																				/>
																			)
																			: assessment?.assessmentScale?.assessmentScaleLevels?.find((scaleLevel) => scaleLevel?.id === assessment?.assessmentScaleLevelPracticalId)?.level,
																},
															]
															: []
														: []
												}
												options={
													assessment?.assessmentScale?.assessmentScaleLevels
														? assessment?.assessmentScale?.assessmentScaleLevels?.map((scaleLevel) => {
															if (scaleLevel?.levelType === "colourStickers") {
																return {
																	value: scaleLevel.id,
																	label: scaleLevel.level,
																	style: {
																		backgroundColor: scaleLevel.level,
																		color: "#fff",
																		fontSize: "25px",
																	},
																};
															} else if (scaleLevel?.levelType === "image") {
																return {
																	value: scaleLevel?.id,
																	label: {
																		type: "img",
																		src: URL.imageSelectURL + scaleLevel?.level,
																		height: "42",
																		width: "42"
																	}
																	// label: 
																	// (
																	// 	<img
																	// 		src={URL.imageSelectURL + scaleLevel?.level}
																	// 		className="img-responsive"
																	// 		height="42"
																	// 		width="42"
																	// 	/>
																	// ),
																};
															} else {
																return {
																	value: scaleLevel?.id,
																	label: scaleLevel?.level,
																};
															}
														})
														: []
												}
												isDisabled={
													assessment.isFinalized ||
													(props.finalizeUnFinalizeVal[item.name] &&
														!props.finalizeUnFinalizeVal[item.name] ===
														true)
												}
												name="level"
												onChange={(e) => {

													setSelectedLvlVal(e);
													props.handleAssessmentScaleForPracticalLevelChange(e, assessment, item.name)
												}

												}
												placeholder="Select Level"
											/>
										</>
									) : assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.mark ? (
										assessment.assessmentScale && (
											<div className="d-flex justify-content-center">
												<div>
													<input
														type="number"
														min={0}
														max={assessment.assessmentScale?.practicalMax}
														value={assessment?.practicalObtainedMarks ?? ""}
														disabled={
															assessment.isFinalized ||
															(props.finalizeUnFinalizeVal[item.name] &&
																!props.finalizeUnFinalizeVal[item.name] ===
																true)
														}
														style={{
															border:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? "1px solid grey"
																	: "1px solid black",
															height: "38px",
															width: "55px",
															textAlign: "center",

															background:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? "#dddddd"
																	: "",
															color:
																assessment.isFinalized ||
																	(props.finalizeUnFinalizeVal[item.name] &&
																		!props.finalizeUnFinalizeVal[item.name] ===
																		true)
																	? "grey"
																	: "",
														}}
														onChange={(count) => {

															props.practicalCounterHandler(
																count.target.value,
																assessment,
																item.name,
															)
														}
														}
														step={0.5}
													/>
												</div>
											</div>
										)
									) : assessment.assessmentScale.assessmentScaleTypeCode ===
										scaleTypeCode.gradePoint ? (
										<Select
											isClearable
											className="w-100"
											closeMenuOnSelect={true}
											// components={animatedComponents}
											components={customComponents}
											value={
												assessment?.assessmentScaleGradePointPracticalId
													? [
														{
															label: assessment?.assessmentScale?.assessmentScaleGradePoints?.filter((item) => item?.id === assessment?.assessmentScaleGradePointPracticalId)[0]?.grade ?? "",
															value: assessment?.assessmentScaleGradePointPracticalId ?? "",
														},
													]
													: null
											}
											options={
												assessment?.assessmentScale?.assessmentScaleGradePoints
													? assessment.assessmentScale.assessmentScaleGradePoints.map((scaleGradePoint) => ({
														value: scaleGradePoint?.id,
														label: scaleGradePoint?.grade,
													}))
													: []
											}
											isDisabled={
												assessment.isFinalized ||
												(props.finalizeUnFinalizeVal[item.name] &&
													!props.finalizeUnFinalizeVal[item.name] ===
													true)
											}
											placeholder="Select Grade Point"
											name="gradePoint"
											onChange={(e) => {

												props.handleAssessmentScalePracticalGradePointChange(
													e,
													assessment,
													item.name,
												)
											}
											}
										/>
									) : null}
								</div>
							)}

							<div className="mt-2">
								<input
									// id={
									//   "isTheoryAbsent" +
									//   assessment.assessmentScale.assessmentScaleTypeCode +
									//   i +
									//   idx
									// }
									type="checkbox"
									name="isPracticalAbsent"
									checked={assessment.isPracticalAbsent}
									disabled={
										assessment.isFinalized ||
										(props.finalizeUnFinalizeVal[item.name] &&
											!props.finalizeUnFinalizeVal[item.name] === true)
									}
									onChange={(e) => {

										props.handleIsAbsentForPractical(e, assessment, item.name)
									}
									}
								/>
								<label
									// htmlFor={
									//   "isTheoryAbsent" +
									//   assessment.assessmentScale.assessmentScaleTypeCode +
									//   i +
									//   idx
									// }
									style={{
										paddingLeft: "5px",
										position: "relative",
										top: "-3px",
									}}
								>
									<strong>Is Absent</strong>
								</label>
							</div>
						</td>
					))}
				</>
			);
		} else {
			return <></>;
		}
	};

	const getFinalizeText = (item) => {
		let practicalFinalize =
			item?.theorySubjectAssessments?.length > 0
				? item.theorySubjectAssessments.some((item) => item.isFinalized)
				: false;
		let theoryFinalze =
			item?.practicalSubjectAssessments?.length > 0
				? item.practicalSubjectAssessments.some((item) => item.isFinalized)
				: false;
		return practicalFinalize || theoryFinalze ? "Unfinalize" : "Finalize";
	};

	// const customComponents = {
	// 	Option: ({ innerProps, innerRef, data, ...props }) => {
	// 		debugger
	// 		if (data.label && data.label.type === "img") {
	// 			return (
	// 				<div ref={innerRef} {...innerProps} {...props}>
	// 					<img
	// 						src={data.label.src}
	// 						className="img-responsive"
	// 						height={data.label.height}
	// 						width={data.label.width}
	// 					/>
	// 				</div>
	// 			);
	// 		}
	// 		return (
	// 			<div ref={innerRef} {...innerProps} {...props} 
	// 			style={data?.style ? { backgroundColor: data?.style?.backgroundColor, color: data?.style?.color, fontSize: "22px",display:"flex", alignItems:"center",justifyContent:"center" } : null}
	// 			>
	// 				{data.label}
	// 			</div>
	// 		);
	// 	},
	// };
	const customComponents = {
		Option: ({ innerProps, innerRef, data, styles, ...props }) => {
			if (data.label && data.label.type === "img") {
				return (
					<div
						ref={innerRef}
						{...innerProps}
						{...props}
						style={{
							...styles,
							backgroundColor: data?.style?.backgroundColor,
							color: data?.style?.color,
						}}
					>
						<img
							src={data.label.src}
							className="img-responsive"
							height={data.label.height}
							width={data.label.width}
						/>
					</div>
				);
			}
			return (
				<div
					ref={innerRef}
					{...innerProps}
					{...props}
					style={{
						...styles,
						backgroundColor: data?.style?.backgroundColor,
						color: data?.style?.color,
						fontSize: "18px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					{data.label}
				</div>
			);
		},
	};

	return (
		<>
			{" "}
			{props.loading || props.finalizeLoader ? (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						gap: "0.5rem",
					}}
				>
					<Spinner color="primary" />

					<p> Loading Data ...</p>
				</div>
			) : !props.allData.length > 0 ? (
				<div className="container-fluid">
					{" "}
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						No Records found
					</div>
				</div>
			) : (
				<>
					<StudentReportGeneration {...props} />

					<div className="container-fluid">
						<div className="row">
							<div
								className="col tt-widgetContent-tab-holder 
								"
								// maxWidthDiv
								style={{
									maxHeight: "55vh",
									marginBottom: "10px",
									overflow: "scroll",
									maxWidth: "86vw",
								}}
							>
								<table className="table table-striped table-bordered">
									<thead
										className="tt-group-header text-center"
										style={{ position: "sticky", top: "-1px", zIndex: 1 }}
									>
										<tr>
											<th width="100px" rowSpan={2}>
												Image
											</th>
											<th width="190px" rowSpan={2}>
												Student Name
											</th>
											{props.allData.map((item, idx) => (
												// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
												<th key={idx} colSpan={getTheoryPracticalLength(item)}>
													<div
														style={{
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
															flexDirection: "column-reverse",
															gap: "0.5rem",
															minWidth: "250px",
														}}
													>
														<span>{item?.name}</span>
														<button
															type="button"
															disabled={!props.subjectFinalize[item.name]}
															className="tt-button tt-button-primary ml-2"
															onClick={() => props.handleFinalize(item)}
														// disabled={
														//   props.finalizeClickable && props.finalize === false
														//     ? false
														//     : true
														// }
														>
															{getFinalizeText(item)}
														</button>
													</div>
												</th>
											))}
										</tr>

										<tr>
											{props.allData.map((item) =>
												getTheoryPracticalTitle(item),
											)}
										</tr>
									</thead>
									<tbody>
										{!props.studentData.length > 0 ? (
											<>No data found</>
										) : (
											props.studentData.map((student, idx) => (
												// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
												<tr key={idx}>
													<td>
														<img
															width="90"
															height="90"
															src={
																student.people.photo
																	? URL.imageSelectURL + student.people.photo
																	: userImage
															}
															style={{ objectFit: "cover" }}
															onError={(e) => handleError(e)}
															alt={`${student.people.name}`}
														/>
													</td>
													<td>
														{student.people
															? student.people.name
															: "Student Name"}
													</td>
													{props.allData.map((item) =>
														getTheoryPracticalTitleData(item, student),
													)}
												</tr>
											))
										)}
									</tbody>
								</table>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="d-flex align-items-center justify-content-end mr-4">
									{finalizeReportPermission && (
										<button
											type="button"
											className="tt-button tt-button-primary mr-2"
											onClick={props.handleSubmit}
											disabled={props.allData.every(
												(item) => getFinalizeText(item) === "Unfinalize",
											)}
										// disabled={
										//   students.length > 0
										//     ? props.finalize
										//       ? true
										//       : false
										//     : true
										// }
										>
											Save Assessment Records
										</button>
									)}

									{/* {finalizeReportPermission ? (
                  <button
                    className="tt-button tt-button-primary ml-2"
                    onClick={props.handleStudentSubjectFinalizeConfirm}
                    disabled={
                      props.finalizeClickable && props.finalize === false
                        ? false
                        : true
                    }
                  >
                    Finalize assessment
                  </button>
                ) : null}

                {unFinalizeReportPermission ? (
                  <button
                    className="tt-button tt-button-primary ml-2"
                    onClick={props.handleStudentSubjectUnFinalizeConfirm}
                    disabled={props.finalize ? false : true}
                  >
                    Unfinalize assessment
                  </button>
                ) : null} */}
								</div>
							</div>
						</div>
					</div>


				</>
			)}
		</>
	);
};

export default StudentDetailRevamp;
